import * as PIXI from "pixi.js";
import { createContext } from "react";

const ReactGraphicsContext = createContext<{
  pixiApp: PIXI.Application;
} | null>(null);

export default ReactGraphicsContext;
